var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C12.9375 0 11.25 1.6875 11.25 3.75V56.25C11.25 58.3125 12.9375 60 15 60H52.5C54.5625 60 56.25 58.3125 56.25 56.25V15L41.25 0H15Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 15H56.25L41.25 0V11.25C41.25 13.3125 42.9375 15 45 15Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 26.25L45 15H56.25V26.25Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.75 48.75C48.75 49.7812 47.9062 50.625 46.875 50.625H5.625C4.59375 50.625 3.75 49.7812 3.75 48.75V30C3.75 28.9688 4.59375 28.125 5.625 28.125H46.875C47.9062 28.125 48.75 28.9688 48.75 30V48.75Z",
    fill: "#F7B84E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2451 45.0001C18.7651 44.7283 18.4651 44.1901 18.7651 43.5601L23.0664 35.1508C23.4714 34.3558 24.5514 34.3258 24.9264 35.1508L29.1526 43.5601C29.7676 44.7283 27.9526 45.6583 27.4145 44.4901L26.7526 43.1701H21.2214L20.5764 44.4901C20.3383 45.0001 19.7833 45.107 19.2451 45.0001ZM25.6895 41.192L23.9964 37.4889L22.1533 41.192H25.6895Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9434 35.5256C30.9434 34.2956 32.9234 34.2506 32.9234 35.5256V44.0831C32.9234 45.3281 30.9434 45.3581 30.9434 44.0831V35.5256Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875 50.625H11.25V52.5H46.875C47.9062 52.5 48.75 51.6562 48.75 50.625V48.75C48.75 49.7812 47.9062 50.625 46.875 50.625Z",
    fill: "#CAD1D8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.019cff39d87a9c9e45ba35a9840f601b.svg";
export { ForwardRef as ReactComponent };